package org.moxultimate.topwithmox.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import org.moxultimate.topwithmox.components.layouts.PageLayoutData
import org.moxultimate.topwithmox.techcrud.add.TechAddPage

/**
 * initTechAddRoute
 * Registers page layout data for the /techadd route.
 *
 * @param ctx Kobweb route initialisation context.
 */
@InitRoute
fun initTechAddRoute(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Add Tech"))
}

/**
 * TechAddRoute
 * Kobweb page entry point for the /techadd route — renders [TechAddPage].
 */
@Page(routeOverride = "techadd")
@Layout(".components.layouts.PageLayout")
@Composable
fun TechAddRoute() {
    TechAddPage()
}
